import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import { RetrieveSchool } from "./types"

export const SchoolQueryKey = createQueryKeys("school", {
  retrieve: (schoolId: string) => ({
    queryKey: ["retrieve-school", schoolId],
  }),
})

type Resource = {
  retrieve: APIFn<RetrieveSchool, { schoolId: string | number }>
}

export const SchoolResource: Resource = {
  retrieve: ({ urlParams, ...config }) =>
    axios.get(`/zyra/v1/schools/${urlParams.schoolId}/`, config),
}
